import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import config from '../config/config.json';
import cookie from 'js-cookie';

const RecipeGrids = ({ recipe }) => {
    return(
        <>
            { recipe && (
                <div data-aos="fade-down" className="recipe">
                    <NavLink className="link-img-recipe d-block mb-2" to={`/recetas/${recipe.id}`}>
                        <img
                            className="w-100 d-block image-grid"
                            src={ `${config.ASSET_URL}/${recipe.image}` }
                        />
                    </NavLink>

                    <NavLink to={`/recetas/${recipe.id}`}>
                        <h3>{ cookie.get('i18next') == 'en' ? recipe.titleEn : recipe.titleEs }</h3>
                    </NavLink>

                    { cookie.get('i18next') === 'en' ?
                        <p><b>Product:</b> { recipe.productNameEn }</p>
                        :
                        <p><b>Producto:</b> { recipe.productNameEs }</p>
                    }

                    <div className="show-more-recipe-wrapper">
                        <Link className="show-recipe-button" to={`/recetas/${recipe.id}`} reloadDocument>
                            { cookie.get('i18next') == 'en' ? "Show more" : "Ver más" }
                        </Link>
                    </div>
                </div>
            )}
        </>
    )
}

export default RecipeGrids;
